/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const headingLevel1 = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M17.6 7c-.6.9-1.5 1.7-2.6 2v1h2v7h2V7h-1.4zM11 11H7V7H5v10h2v-4h4v4h2V7h-2v4z" />
	</SVG>
);

export default headingLevel1;
